module.exports = __webpack_public_path__ + "static/img/隆携logo.c2dc2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/隆携logo.png
// module id = lXbO
// module chunks = 1